import AU from '@/public/images/icons/countries/AU.svg';
import AT from '@/public/images/icons/countries/AT.svg';
import BE from '@/public/images/icons/countries/BE.svg';
import BR from '@/public/images/icons/countries/BR.svg';
import BG from '@/public/images/icons/countries/BG.svg';
import CA from '@/public/images/icons/countries/CA.svg';
import HR from '@/public/images/icons/countries/HR.svg';
import CY from '@/public/images/icons/countries/CY.svg';
import CZ from '@/public/images/icons/countries/CZ.svg';
import DK from '@/public/images/icons/countries/DK.svg';
import EE from '@/public/images/icons/countries/EE.svg';
import FI from '@/public/images/icons/countries/FI.svg';
import FR from '@/public/images/icons/countries/FR.svg';
import DE from '@/public/images/icons/countries/DE.svg';
import GI from '@/public/images/icons/countries/GI.svg';
import GR from '@/public/images/icons/countries/GR.svg';
import HK from '@/public/images/icons/countries/HK.svg';
import HU from '@/public/images/icons/countries/HU.svg';
import IN from '@/public/images/icons/countries/IN.svg';
import ID from '@/public/images/icons/countries/ID.svg';
import IE from '@/public/images/icons/countries/IE.svg';
import IT from '@/public/images/icons/countries/IT.svg';
import JP from '@/public/images/icons/countries/JP.svg';
import LV from '@/public/images/icons/countries/LV.svg';
import LI from '@/public/images/icons/countries/LI.svg';
import LT from '@/public/images/icons/countries/LT.svg';
import LU from '@/public/images/icons/countries/LU.svg';
import MY from '@/public/images/icons/countries/MY.svg';
import MT from '@/public/images/icons/countries/MT.svg';
import MX from '@/public/images/icons/countries/MX.svg';
import NL from '@/public/images/icons/countries/NL.svg';
import NZ from '@/public/images/icons/countries/NZ.svg';
import NO from '@/public/images/icons/countries/NO.svg';
import PL from '@/public/images/icons/countries/PL.svg';
import PT from '@/public/images/icons/countries/PT.svg';
import RO from '@/public/images/icons/countries/RO.svg';
import SG from '@/public/images/icons/countries/SG.svg';
import SK from '@/public/images/icons/countries/SK.svg';
import SI from '@/public/images/icons/countries/SI.svg';
import ES from '@/public/images/icons/countries/ES.svg';
import SE from '@/public/images/icons/countries/SE.svg';
import CH from '@/public/images/icons/countries/CH.svg';
import TH from '@/public/images/icons/countries/TH.svg';
import AE from '@/public/images/icons/countries/AE.svg';
import GB from '@/public/images/icons/countries/GB.svg';
import US from '@/public/images/icons/countries/US.svg';
export const countriesWithFlagsAndPrefix = [
  { id: 11, name: 'Australia', cc: 'AU', flag: AU, phonePrefix: '+61' },
  { id: 2, name: 'Austria', cc: 'AT', flag: AT, phonePrefix: '+43' },
  { id: 3, name: 'Belgium', cc: 'BE', flag: BE, phonePrefix: '+32' },
  { id: 39, name: 'Brazil', cc: 'BR', flag: BR, phonePrefix: '+55' },
  { id: 12, name: 'Bulgaria', cc: 'BG', flag: BG, phonePrefix: '+359' },
  { id: 22, name: 'Canada', cc: 'CA', flag: CA, phonePrefix: '+1' },
  { id: 13, name: 'Croatia', cc: 'HR', flag: HR, phonePrefix: '+385' },
  { id: 15, name: 'Cyprus', cc: 'CY', flag: CY, phonePrefix: '+357' },
  { id: 10, name: 'Czech Republic', cc: 'CZ', flag: CZ, phonePrefix: '+420' },
  { id: 23, name: 'Denmark', cc: 'DK', flag: DK, phonePrefix: '+45' },
  { id: 14, name: 'Estonia', cc: 'EE', flag: EE, phonePrefix: '+372' },
  { id: 18, name: 'Finland', cc: 'FI', flag: FI, phonePrefix: '+358' },
  { id: 5, name: 'France', cc: 'FR', flag: FR, phonePrefix: '+33' },
  { id: 1, name: 'Germany', cc: 'DE', flag: DE, phonePrefix: '+49' },
  { id: 35, name: 'Gibraltar', cc: 'GI', flag: GI, phonePrefix: '+350' },
  { id: 16, name: 'Greece', cc: 'GR', flag: GR, phonePrefix: '+30' },
  {
    id: 24,
    name: 'Hong Kong SAR China',
    cc: 'HK',
    flag: HK,
    phonePrefix: '+852',
  },
  { id: 32, name: 'Hungary', cc: 'HU', flag: HU, phonePrefix: '+36' },
  { id: 37, name: 'India', cc: 'IN', flag: IN, phonePrefix: '+91' },
  { id: 17, name: 'Indonesia', cc: 'ID', flag: ID, phonePrefix: '+62' },
  { id: 25, name: 'Ireland', cc: 'IE', flag: IE, phonePrefix: '+353' },
  { id: 8, name: 'Italy', cc: 'IT', flag: IT, phonePrefix: '+39' },
  { id: 40, name: 'Japan', cc: 'JP', flag: JP, phonePrefix: '+81' },
  { id: 26, name: 'Latvia', cc: 'LV', flag: LV, phonePrefix: '+371' },
  { id: 33, name: 'Liechtenstein', cc: 'LI', flag: LI, phonePrefix: '+423' },
  { id: 41, name: 'Lithuania', cc: 'LT', flag: LT, phonePrefix: '+370' },
  { id: 4, name: 'Luxembourg', cc: 'LU', flag: LU, phonePrefix: '+352' },
  { id: 27, name: 'Malaysia', cc: 'MY', flag: MY, phonePrefix: '+60' },
  { id: 34, name: 'Malta', cc: 'MT', flag: MT, phonePrefix: '+356' },
  { id: 42, name: 'Mexico', cc: 'MX', flag: MX, phonePrefix: '+52' },
  { id: 43, name: 'Netherlands', cc: 'NL', flag: NL, phonePrefix: '+31' },
  { id: 28, name: 'New Zealand', cc: 'NZ', flag: NZ, phonePrefix: '+64' },
  { id: 44, name: 'Norway', cc: 'NO', flag: NO, phonePrefix: '+47' },
  { id: 9, name: 'Poland', cc: 'PL', flag: PL, phonePrefix: '+48' },
  { id: 7, name: 'Portugal', cc: 'PT', flag: PT, phonePrefix: '+351' },
  { id: 36, name: 'Romania', cc: 'RO', flag: RO, phonePrefix: '+40' },
  { id: 45, name: 'Singapore', cc: 'SG', flag: SG, phonePrefix: '+65' },
  { id: 19, name: 'Slovakia', cc: 'SK', flag: SK, phonePrefix: '+421' },
  { id: 31, name: 'Slovenia', cc: 'SI', flag: SI, phonePrefix: '+386' },
  { id: 6, name: 'Spain', cc: 'ES', flag: ES, phonePrefix: '+34' },
  { id: 20, name: 'Sweden', cc: 'SE', flag: SE, phonePrefix: '+46' },
  { id: 29, name: 'Switzerland', cc: 'CH', flag: CH, phonePrefix: '+41' },
  { id: 38, name: 'Thailand', cc: 'TH', flag: TH, phonePrefix: '+66' },
  {
    id: 46,
    name: 'United Arab Emirates',
    cc: 'AE',
    flag: AE,
    phonePrefix: '+971',
  },
  { id: 21, name: 'United Kingdom', cc: 'GB', flag: GB, phonePrefix: '+44' },
  { id: 30, name: 'United States', cc: 'US', flag: US, phonePrefix: '+1' },
];
